import { combineReducers } from 'redux';

import transactions from './reports';
import slips from './reportsSlips';
import reportsFinancing from './reportsFinancing';
import details from './dialogs';

const reducer = combineReducers({
  [transactions.name]: transactions.reducer,
  [reportsFinancing.name]: reportsFinancing.reducer,
  [slips.name]: slips.reducer,
  [details.name]: details.reducer,
});

export default reducer;
